import { dispatch } from '@restore/helpers';
import { SaveDraftReadingTaskAction } from '@restore/readerViewerSession/formManagement/formManagement.types';
import { readerTaskSlice } from '@restore/readerTask/readerTask.slice';
import { formManagementSlice } from '@restore/readerViewerSession/formManagement/formManagement.slice';

export function* saveDraftReadingTaskWorker({
  payload,
}: SaveDraftReadingTaskAction) {
  yield dispatch(readerTaskSlice.actions.saveReaderTask(payload));
  yield dispatch(formManagementSlice.actions.setFormDirty(false));
}
